import HealthCheckSaveModal from "components/Dashboard/HealthCheckSaveModal";
import GraphDashboard from "pages/PHC/Dashboard/GraphDashboard";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PHCOnboardingActions } from "stores/PHC/PHCOnboarding/PHCOnboardingAction";
import { PHCOnboardingApis } from "stores/PHC/PHCOnboarding/PHCOnboardingApis";

function PHCGenerateReport() {
  const [modalOpen, setModalOpen] = useState(false);
  const [tags, setTags] = useState([
    { id: 1, TagName: "Portfolio 1", Active: true },
  ]);

  const getID = useSelector((state) => state.PHC.PHCOnboarding.portfolioId);
  const dispatch = useDispatch();
  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleSaveName = async (newName) => {
    const updated = tags.map((t) =>
      t.Active ? { ...t, TagName: newName } : t
    );

    const payload = {
      portfolioId: getID,
      portfolioName: newName,
    };

    await PHCOnboardingApis.saveReport(payload);
    dispatch(PHCOnboardingActions.getOnboardingData());
    setTags(updated);
    setModalOpen(false);
  };

  return (
    <div>
      <GraphDashboard openModal={handleOpenModal} portfolioId={getID} />

      <HealthCheckSaveModal
        open={modalOpen}
        onClose={handleCloseModal}
        tagName={tags ? tags.TagName : ""}
        onSave={handleSaveName}
      />
    </div>
  );
}

export default PHCGenerateReport;
